import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const FriendlyCaptchaApi = {
	Verify(model, documents) {
		const serviceUrl = prependRoot('friendlyCaptcha', getApiRoot());
		return axios.post(serviceUrl, model
			,{
				headers:{
					"accept": "application/json"
				}
			});
	}
};

export default FriendlyCaptchaApi;
